import { AiFillDashboard } from 'react-icons/ai'
import { FaClipboardList,FaCopy } from 'react-icons/fa'
import { RiLogoutBoxLine } from 'react-icons/ri';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { toast } from 'react-toastify';    


import logo from './../img/dashboard-logo.cca6d925.svg';


toast.configure()
const Navbar = (props) => {
    // const [copied, setCopied] = useState(false)

    // function notify() { 
    //     toast('Copied!')
    // }

    function logout() {
        console.log('Log out')
    }

  return (
    <>
        <div className='mobile__navbar'> 
        
            <div onClick={props.toggleAccountPage} className={`navbar__item ${props.accountPage ? 'active' : 'n'}`}>
                <AiFillDashboard className='navbar__item__icon' />
                <h6 className={`navbar__item__text ${props.accountPage ? 'active' : 'n'}`}>Dashboard</h6>
            </div>
            <div onClick={props.toggleTransacrionPage} className={`navbar__item ${props.transactionPage ? 'active' : 'n'}`}>
                <FaClipboardList className='navbar__item__icon' />
                <h6 className={`navbar__item__text ${props.transactionPage ? 'active' : 'n'}`}>Transactions</h6>
            </div>
            <div onClick={logout} className="navbar__item">
                <RiLogoutBoxLine  className='navbar__item__icon' />
                <h6 className="navbar__item__text">Sign Out</h6>
            </div>

        </div>

        <div className="side__navbar">
            
            <div className="logo">
                <img className='logo__img' src={logo} alt="logo"/>
                <span>Scalex</span>
            </div>

            <div className="header__username__container">
                <h4 className='user__id'>Your ID: 
                <span>{props.userID} &nbsp; 
                    <CopyToClipboard text={props.userID}>
                        <button className='copy__btn'><FaCopy onClick={() => toast.success('Copied!')} className='blueColor' /> </button>
                    </CopyToClipboard>
                </span> 
            </h4>
            { props.copied ? <h6 className='copied'>Copied.</h6> : null}

            </div>

            
            <div className="side__navbar__items">
            
                <div className={`navbar__item ${props.accountPage ? 'active' : 'n'}`}>
                    <AiFillDashboard onClick={props.toggleAccountPage}  className='navbar__item__icon' />
                    <h6 onClick={props.toggleAccountPage}  className={`navbar__item__text ${props.accountPage ? 'active' : 'n'}`}>Dashboard</h6>
                </div>

                <div className={`navbar__item ${props.transactionPage ? 'active' : 'n'}`}>
                    <FaClipboardList  onClick={props.toggleTransacrionPage} className='navbar__item__icon' />
                    <h6 onClick={props.toggleTransacrionPage}  className={`navbar__item__text ${props.transactionPage ? 'active' : 'n'}`}>Transactions</h6>
                </div>

                <div className="navbar__item">
                    <RiLogoutBoxLine  onClick={logout} className='navbar__item__icon' />
                    <h6  onClick={logout} className="navbar__item__text">Sign Out</h6>
                </div>

            </div>
        </div>
    </>
  )
}

export default Navbar